import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import ClaimActions from 'app/shared/actions/ClaimActions';

import ClaimListingCard from 'app/shared/components/ClaimListingCard';
import ModalFooter from 'app/shared/components/Modal/ModalFooter';

import ListingClaimUtils from 'app/shared/utils/listingClaimUtils';

const {
    isEmailInContactMethods,
    isPhoneInContactMethods,
} = ListingClaimUtils;

import {
    DialogBody,
    Heading,
    ModalDialog,
    Spacer,
} from '@zillow/constellation';

import { Center } from '@zillow/zrs-comet';

const propTypes = {
    onSubmitSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    listings: PropTypes.array.isRequired,
    contactMethods: PropTypes.array.isRequired,
};

const ListingRemovalModal = ({
    onSubmitSuccess,
    onClose,
    listings,
    contactMethods,
}) => {
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    const handleSubmitClick = () => {
        setIsSubmitting(true);
        setHasError(false);
        dispatch(ClaimActions.deleteAllUnverifiedClaimMethod())
            .then(() => onSubmitSuccess())
            .catch(() => setHasError(true))
            .finally(() => setIsSubmitting(false));
    };

    const renderContent = () => (
        <DialogBody>
            <Center>
                <b>The following listings will be removed due to unverified contact methods</b>
            </Center>
            <Spacer marginTop="sm" marginBottom="sm">
                <Center fontType="body">
                    You can always come back to this tool to add them back in
                </Center>
            </Spacer>
            {listings.map(listing => (
                <ClaimListingCard
                    listingData={listing}
                    highlightPhone={isPhoneInContactMethods(contactMethods, listing.contactPhone)}
                    highlightEmail={isEmailInContactMethods(contactMethods, listing.contactEmail)}
                />
            ))}
        </DialogBody>
    );
    const renderFooter = () => (
        <ModalFooter
            cancelText="Back to verify"
            onCancel={onClose}
            onSubmit={handleSubmitClick}
            isSubmitting={isSubmitting}
            hasError={hasError}
        />
    );

    return (
        <ModalDialog
            isOpen={true}
            onClose={onClose}
            mediaQuery={{ xs: { fullScreen: true }, md: { fullScreen: false } }}
            wide={true}
            header={<Heading level={6}>Listing Removal</Heading>}
            body={renderContent()}
            footer={renderFooter()}
        />
    );
};

ListingRemovalModal.propTypes = propTypes;

export { ListingRemovalModal };
export default ListingRemovalModal;
